import { LS_KEYS } from '../helpers/window';
import { actions as authActions } from './slices/authSlice';

interface AuthTokenStore {
  getState: () => {
    auth: {
      token: string;
    };
  };
  dispatch: (action: ReturnType<typeof authActions.authenticate>) => void;
}

export const listenForAuthTokenStorage = (authStore: AuthTokenStore): () => void => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const handleStorage = (event: StorageEvent) => {
    // A null key means localStorage.clear() was called in another tab.
    const isLocalStorageClear = event.key === null && event.storageArea === window.localStorage;

    if (event.key !== LS_KEYS.AUTH_TOKEN && !isLocalStorageClear) {
      return;
    }

    const storedToken = window.localStorage.getItem(LS_KEYS.AUTH_TOKEN) || undefined;
    const reduxToken = authStore.getState().auth.token || undefined;

    // Only update if the token is different from the current token.
    if (storedToken === reduxToken) {
      return;
    }

    authStore.dispatch(authActions.authenticate(storedToken));
  };

  window.addEventListener('storage', handleStorage);

  return () => {
    window.removeEventListener('storage', handleStorage);
  };
};
